<template lang="pug">
div.spinner-wrapper
  svg(
      :width="cmptWidth"
      :height="cmptHeight"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      class="lds-infinity"
      style="background: none")
      path(
        fill="none"
        d="M24.3,30C11.4,30,5,43.3,5,50s6.4,20,19.3,20c19.3,0,32.1-40,51.4-40 C88.6,30,95,43.3,95,50s-6.4,20-19.3,20C56.4,70,43.6,30,24.3,30z"
        stroke="#47a3da"
        stroke-width="4"
        stroke-dasharray="153.95335693359377 102.63557128906248")
        animate(
          attributeName="stroke-dashoffset"
          calcMode="linear"
          values="0;256.58892822265625"
          keyTimes="0;1"
          dur="1.2"
          begin="0s"
          repeatCount="indefinite")
</template>

<script>
export default {
    name: 'Spinner',
    props: {
        width: {
            type: String,
            required: true
        },
        height: {
            type: String,
            required: true
        }
    },

    computed: {
        cmptWidth() {
            return `${this.width}px`
        },
        cmptHeight() {
            return `${this.height}px`
        }
    }
}
</script>
